export default __webpack_public_path__ + "static/media/heroImage1.b1b7f814.png";